<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vii">
<h2 class="fm_title">List of Plates</h2>
<p class="noindenta">A Spartan points out a drunken slave to his sons; painting by Fernand Sabatte, 1900.</p>
<p class="noindenta">A Persian combat engineer mounted on a donkey.</p>
<p class="noindenta">The entrance to the Temple of Apollo at Delphi.</p>
<p class="noindenta">A Persian archer, from an Athenian black-figure vase.</p>
<p class="noindenta">Greek infantry depicted on a frieze.</p>
<p class="noindenta">The Leonidian in modern Sparta.</p>
<p class="noindenta">The view across Sparta to Mt Parnon.</p>
<p class="noindenta">A contemporary woman’s jewellery.</p>
<p class="noindenta">A mother arms her son before battle.</p>
<p class="noindenta">Mount Ithome depicted in an 1882 woodcut.</p>
<p class="noindenta">The medieval monastery at Mystras.</p>
<p class="noindenta">King Nabis, portrait taken from a contemporary coin.</p>
<p class="noindenta">Philip II of Macedon.</p>
<p class="noindenta">The Spartan acropolis looking west across modern Sparta.</p>
<p class="noindenta">Modern Sparta with the Taygetos range in the background.</p>
<p class="noindenta">The remains of the theatre, as seen from the Spartan acropolis.</p>
<p class="noindenta">The remains of the walls of Sparta.</p>
<p class="noindenta">A single olive tree of tough wood, illustrating the difficulty of destroying even a few acres of such trees.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_List_of_Plates.vue?24efa3d8